import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { eventMap, userBehaviorSequence } from "@/api/dataAll/dataAll";
export default {
  name: "userBehaviorSequence",
  mixins: [tabulation],
  data: function data() {
    var _baseInfo;

    return {
      activeNames: ['1', '2'],
      date: [],
      paramsData: {
        deduplicate: 'none',
        dimensionKind: 'user'
      },
      deviceList: [{
        label: this.$t('userLabel'),
        value: 'user'
      }, {
        label: this.$t('device'),
        value: 'device'
      }],
      dateList: [{
        label: this.$t('noneLabel'),
        value: 'none'
      }, {
        label: this.$t('byDay'),
        value: 'day'
      }, {
        label: this.$t('byWeek'),
        value: 'week'
      }, {
        label: this.$t('byMonth'),
        value: 'month'
      }, {
        label: this.$t('byYear'),
        value: 'year'
      }],
      funcList: [],
      payInfo: {
        pay_count: 0,
        pay_amount: 0
      },
      baseInfo: (_baseInfo = {}, _defineProperty(_baseInfo, this.$t('registerTime'), '--'), _defineProperty(_baseInfo, this.$t('customerId'), '--'), _defineProperty(_baseInfo, this.$t('mediaPlatform'), '--'), _defineProperty(_baseInfo, this.$t('clientChannel'), '--'), _defineProperty(_baseInfo, this.$t('promotionActivity'), this.$t('defaultLabel')), _defineProperty(_baseInfo, this.$t('userName'), '--'), _baseInfo),
      activities: [],
      activitiesGroup: [],
      baseLinkInfo: {},
      reqLoading: false
    };
  },
  created: function created() {
    var time = this.$times.timestampToTime(this.$times.zeroTimeZone() / 1000, 'YY-MM-DD');
    this.date[0] = time;
    this.date[1] = time;
    this.getEventMapList();
  },
  methods: {
    getEventMapList: function getEventMapList(page) {
      var _this = this;

      eventMap({
        game_id: this.rawData.game_id,
        page_size: -1
      }).then(function (res) {
        _this.funcList = res.data || [];
      });
    },
    gotoSearch: function gotoSearch(row) {
      var user_id = '';
      var device_id = '';

      if (this.paramsData.dimensionKind == 'user') {
        user_id = this.baseLinkInfo.user_id;
      } else {
        device_id = this.baseLinkInfo.device_id;
      }

      this.$router.replace({
        name: 'customEvents',
        params: {
          func: row.func,
          user_id: user_id,
          device_id: device_id,
          starttime: this.date ? this.date[0] : '',
          endtime: this.date ? this.date[1] : ''
        }
      });
    },
    getList: function getList() {
      var _this2 = this;

      this.paramsData.start_time = this.date && this.date[0];
      this.paramsData.end_time = this.date && this.date[1];

      if (!this.paramsData.play_id) {
        this.$message.error(this.$t('pleaseInputUserIdOrDeviceId'));
        return;
      }

      this.reqLoading = true;
      userBehaviorSequence(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        game_id: this.rawData.game_id
      })).then(function (res) {
        if (res.status == 200) {
          var _this2$baseInfo;

          _this2.reqLoading = false;
          var info = res.data.user_info;
          _this2.baseLinkInfo = res.data.user_info;
          _this2.baseInfo = (_this2$baseInfo = {}, _defineProperty(_this2$baseInfo, _this2.$t('registerTime'), info.time || '--'), _defineProperty(_this2$baseInfo, _this2.$t('customerId'), info.user_id || '--'), _defineProperty(_this2$baseInfo, _this2.$t('mediaPlatform'), info.ad_channel + ',' + info.ad_placement || '--'), _defineProperty(_this2$baseInfo, _this2.$t('clientChannel'), info.channel || '--'), _defineProperty(_this2$baseInfo, _this2.$t('promotionActivity'), _this2.$t('defaultLabel')), _defineProperty(_this2$baseInfo, _this2.$t('userName'), info.role_name || '--'), _this2$baseInfo);
          _this2.payInfo = {
            pay_count: info.pay_count,
            pay_amount: info.pay_amount
          };
          var rawEvents = res.data.events || [];
          var groups = {};
          rawEvents.forEach(function (item) {
            // 提取日期部分 (取 "2025-07-25 00:00:00" 的前10位)
            var date = item.time.split(' ')[0];

            if (!groups[date]) {
              groups[date] = [];
            }

            groups[date].push({
              content: item.event,
              timestamp: item.time,
              func: item.func,
              ext: item.ext,
              action: item.action,
              expanded: false
            });
          });
          _this2.activitiesGroup = Object.keys(groups).sort(function (a, b) {
            return b.localeCompare(a);
          }).map(function (date) {
            return {
              date: date,
              list: groups[date]
            };
          });
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    }
  }
};